(function($, Drupal, drupalSettings) {

    Drupal.behaviors.scrollableTable = {
        attach: function attach(context) {
            $('table', context).wrap('<div class="scrollableTable"></div>');

        }
    };

    Drupal.behaviors.aos = {
        attach: function(context, settings) {

            $('.field--name-field-content > .field--item , .field--name-field-related-pages', context).once('aos').each(function () {
                $(this).attr('data-aos', 'fade-up');
                AOS.init({
                    offset: 100,
                    once: true,
                    anchorPlacement: 'top-bottom',
                });
            });
            $(window).on('load', function(){
                AOS.refresh();
            });
        }
    };

    Drupal.behaviors.date_cleaner = {
        attach: function(context, settings) {

            $('.field--name-field-publication-date > time, .field--name-field-start-date > time, .views-field-field-publication-date time', context).once('time').each(function () {
                var string = $(this).text().replace(' - 00:00','');
                $(this).text(string);
            });
            $('.field--name-field-end-date > time, .views-field-field-publication-date time', context).once('time').each(function () {
                var string = $(this).text().replace(' - 23:59','');
                $(this).text(string);
            });

        }
    };

    /*
     http://dummy.com/?technology=jquery&blog=jquerybyexample.

     var tech = getUrlParameter('technology');
     var blog = getUrlParameter('blog');
     */
    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : sParameterName[1];
            }
        }
    };


    Drupal.behaviors.backtotop = {
        attach: function (context, settings) {

            $('body', context).once('backtotop').each(function () {

                var backTop = $('.js-cd-top');
                // browser window scroll (in pixels) after which the "back to top" link is shown
                offset = 300;
                //browser window scroll (in pixels) after which the "back to top" link opacity is reduced
                offsetOpacity = 1200;
                scrollDuration = 700;
                scrolling = false;
                if (backTop) {
                    //update back to top visibility on scrolling
                    window.addEventListener("scroll", function (event) {
                        if (!scrolling) {
                            scrolling = true;
                            (!window.requestAnimationFrame) ? setTimeout(checkBackToTop, 250) : window.requestAnimationFrame(checkBackToTop);
                        }
                    });
                    //smooth scroll to top

                    backTop.click(function (event) {
                        event.preventDefault();
                        (!window.requestAnimationFrame) ? window.scrollTo(0, 0) : scrollTop(scrollDuration);
                    });
                }

                function checkBackToTop() {
                    var windowTop = window.scrollY || document.documentElement.scrollTop;
                    ( windowTop > offset ) ? backTop.addClass('cd-top--show') : backTop.removeClass('cd-top--show cd-top--fade-out');
                    ( windowTop > offsetOpacity ) && backTop.addClass('cd-top--fade-out');
                    scrolling = false;
                }

                function scrollTop(duration) {
                    var start = window.scrollY || document.documentElement.scrollTop,
                        currentTime = null;

                    var animateScroll = function (timestamp) {
                        if (!currentTime) currentTime = timestamp;
                        var progress = timestamp - currentTime;
                        var val = Math.max(Math.easeInOutQuad(progress, start, -start, duration), 0);
                        window.scrollTo(0, val);
                        if (progress < duration) {
                            window.requestAnimationFrame(animateScroll);
                        }
                    };

                    window.requestAnimationFrame(animateScroll);
                }

                Math.easeInOutQuad = function (t, b, c, d) {
                    t /= d / 2;
                    if (t < 1) return c / 2 * t * t + b;
                    t--;
                    return -c / 2 * (t * (t - 2) - 1) + b;
                };
            });
        }
    }
    
  /**
   * Gestione di outdatedBrowser
   */
  Drupal.behaviors.outdatedBrowserBehaviors = {
    attach: function (context, settings) {
      $('body', context).once('outdatedBrowserBehaviors').each(function(){

        var myLang    = ($('html[lang="en"]').length > 0) ? 'en' : 'it',
            themePath = drupalSettings.path.baseUrl + drupalSettings.path.themeUrl,
            outdPath  = themePath + "/outdated/lang/",
            langPath  = outdPath + myLang + ".html";

        outdatedBrowser({
          bgColor:      '#2E2E2E',
          color:        '#ffffff',
          lowerThan:    'object-fit',
          languagePath: langPath
        });
      });
    }
  };    

})(jQuery, Drupal, drupalSettings);



(function ($) {

    $(document).ready(function () {
      $('.materiality-matrix .dot').hover(function(){
        if (window.innerWidth>767) {
            $('.materiality-matrix-content').toggle().attr('class','materiality-matrix-content').addClass($(this).data("category")).children().html($(this).children().html());
        }
        else {
          $(this).children().toggle();
          $('.materiality-matrix-boxes-inner').toggleClass('matrix-blur');
          $(this).toggleClass('dot-clear');
        }
      });


      $('.materiality-matrix .legend-single').on('click touch', function(){
        $(this).toggleClass('legend-active');
        if ($('.materiality-matrix .legend-active').length) {
          $('.materiality-matrix .dot').hide();
          $('.materiality-matrix .legend-active').each(function(i){
              $('.materiality-matrix .dot[data-category="'+$(this).data("category")+'"]').show();
          });
        }
        else {
          $('.materiality-matrix .dot').show();
        }

      });

      $('.presenza-geografica-container').hover(function(){
        if (window.innerWidth>767) {
            $(this).find('.presenza-geografica-tooltip').fadeToggle();
        }
      });
      $('.presenza-geografica-container').click(function(){
        if (window.innerWidth<768) {
          if (!$(this).hasClass('open')) {
            $('.presenza-geografica-container').removeClass('open').find('.content').slideUp();
            $('.presenza-geografica-container').find('.title').removeClass('invisible').slideDown();
          }
            $(this).toggleClass('open').find('.content').slideToggle();
            $(this).find('.title').toggleClass('invisible').slideToggle();
        }
      });

      $('.person-pdf-download').click(function(e){
        e.preventDefault();
        $(this).parents('.paragraph--type--person').find('.cda_popup').addClass('cda-show');
        $('body').addClass('body-noscroll');
      });

      $('.close-modal').click(function(e){
        e.preventDefault();
        $(this).parents('.cda_popup').removeClass('cda-show');
        $('body').removeClass('body-noscroll');
      });

      if ($('.field--name-field-benchmark-yearly').length) {
        $('.field--name-field-benchmark-yearly, .field--name-field-benchmark-yearly-values').addClass('active');
        $('.field--name-field-benchmark-weekly, .field--name-field-benchmark-yearly').click(function(){
          if (!$(this).hasClass('active')) {
              $('.field--name-field-benchmark-yearly,.field--name-field-benchmark-weekly,.field--name-field-benchmark-yearly-values,.field--name-field-benchmark-weekly-value').toggleClass('active');
          }
        });
      }

    });

})(jQuery);
